<template>
  <div class="bq-product-jkyl">
    <div class="bq-product-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-product-title-wrap" :class="animateTitle">
          <div
            class="bq-product-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div class="bq-product-subtitle">
            通过标准化健康医疗数据中心的建设，有效提高数据质量，解耦各系统间复杂对接，形成数据标准，结合数据分析，挖掘数据价值，提供数据决策，让数据成为真正生产力
          </div>
        </div>
      </div>
    </div>
    <div class="bq-product-content">
      <BqTab
        :tabs="tabs"
        :layout="'vertical'"
        :activeIndex="activeIndex"
        @handleClick="handleClick"
      >
        <div v-for="item in tabs" :key="item.slot" :slot="item.slot">
          <keep-alive>
            <component :is="item.slot"></component>
          </keep-alive>
        </div>
      </BqTab>
    </div>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import zsjgl from './zsjgl';
import fwgl from './fwgl';
import zsygl from './zsygl';
import tysfrzsq from './tysfrzsq';
import ywjk from './ywjk';
import sjzlgl from './sjzlgl';
export default {
  name: 'Jkyl',
  components: {
    BqTab,
    zsjgl,
    fwgl,
    zsygl,
    tysfrzsq,
    ywjk,
    sjzlgl,
  },
  data() {
    return {
      animateTitle: [],
      activeIndex: 0,
      titlebg:
        'https://img.alicdn.com/tfs/TB1azTGDW61gK0jSZFlXXXDKFXa-649-51.png',
      cover:
        'https://img.alicdn.com/tfs/TB1sPowgsKfxu4jSZPfXXb3dXXa-1920-380.png',
      tabs: [
        {
          title: '主数据管理平台',
          slot: 'zsjgl',
        },
        {
          title: '服务管理平台',
          slot: 'fwgl',
        },
        {
          title: '主索引管理平台',
          slot: 'zsygl',
        },
        {
          title: '统一身份认证授权平台',
          slot: 'tysfrzsq',
        },
        {
          title: '业务监控平台',
          slot: 'ywjk',
        },
        {
          title: '数据质量管理平台',
          slot: 'sjzlgl',
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-product-jkyl {
  .bq-product-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;

      .bq-product-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 122px;
        // right: 360px;
        right: 50%;
        transform: translateX(50%);

        &.animate-title {
          .bq-product-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 500%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-product-subtitle {
            transform: translate3d(0, 0, 0);
            opacity: 1;

            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-product-title {
        // opacity: 0;
        width: 649px;
        height: 51px;
        margin-bottom: 50px;
      }
      .bq-product-subtitle {
        opacity: 0;
        width: 900px;
        text-align: left;
        font-size: 18px;
      }
    }
  }

  .bq-product-content {
    padding: 90px 0;
  }
}
</style>
